import * as recallApi from '@otter-ai/recall-client';
import { useMutation } from '@tanstack/react-query';
import { APP_ID } from '@/constants/constant';
import type { FinishOnboardingStepType } from '@/shared/types/welcome';

export const useFinishOnboardingStepMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (res: FinishOnboardingStepType) => void;
  onError?: (error: {
    status?: string;
    message?: string;
    code?: number;
  }) => void;
}) => {
  return useMutation({
    mutationFn: async ({
      steps,
      reveal_members_with_va,
      name,
      answer,
      skipped,
    }: {
      steps?: string;
      reveal_members_with_va?: boolean;
      name: string;
      answer?: string;
      skipped?: boolean;
    }) => {
      const query = {
        appid: APP_ID,
        ...(steps && { steps }),
        ...(reveal_members_with_va && {
          reveal_members_with_va: reveal_members_with_va.toString(),
        }),
      };

      const body = {
        name,
        ...(answer && { answer }),
        ...(skipped && { skipped: skipped.toString() }),
      };

      const response = await recallApi.finishOnboardingStep({
        query,
        body,
        throwOnError: true,
      });

      return response.data;
    },
    onSuccess,
    onError,
  });
};
